import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const OccupationSubareaRow = ({ subarea, startInEditMode = false, onSave, onCancel, onDelete }) => {
  const [editing, setEditing] = useState(startInEditMode);
  const [draft, setDraft] = useState({ key: subarea?.key ?? '', name: subarea?.name ?? '' });

  const startEditing = () => {
    setDraft({ key: subarea.key, name: subarea.name });
    setEditing(true);
  };

  const cancelEditing = () => {
    if (subarea) {
      setEditing(false);
    } else {
      onCancel();
    }
  };

  const save = async () => {
    await onSave(draft);
    if (subarea) {
      setEditing(false);
    } else {
      onCancel();
    }
  };

  if (editing) {
    return (
      <ListItem>
        <Box sx={{ display: 'flex', gap: 2, width: '100%', alignItems: 'center' }}>
          <TextField
            required
            label="Clave"
            variant="standard"
            value={draft.key}
            onChange={(event) => setDraft({ ...draft, key: event.target.value })}
          />
          <TextField
            required
            label="Nombre"
            variant="standard"
            fullWidth
            value={draft.name}
            onChange={(event) => setDraft({ ...draft, name: event.target.value })}
          />
          <Button
            disabled={!draft.key.trim() || !draft.name.trim()}
            onClick={save}
          >
            Guardar
          </Button>
          <Button onClick={cancelEditing}>
            Cancelar
          </Button>
        </Box>
      </ListItem>
    );
  }

  return (
    <ListItem
      secondaryAction={
        <>
          <IconButton edge="end" aria-label="editar" onClick={startEditing}>
            <EditIcon />
          </IconButton>
          <IconButton edge="end" aria-label="eliminar" onClick={() => onDelete(subarea)}>
            <DeleteIcon />
          </IconButton>
        </>
      }
    >
      <ListItemText primary={subarea.name} secondary={subarea.key} />
    </ListItem>
  );
};

export default OccupationSubareaRow;
